module.exports = __webpack_public_path__ + "static/5fca078c2b95df142142ca7eae1c2e9a882a1b6e36206e9f2e211a5584f36ef7-75cafa1d49157813b68bda8e59c8d90b.png";